<template>
    <div>
        <div :class="{'show': toggleModal }" class="modal fade">
            <div class="modal-dialog modal-dialog-lg modal-lg">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4">{{$t('button_link.stock_in_out')}}
                            <small class="m-0 text-muted">{{stockTitle}}</small>
                        </h5>
                        <button type="button" class="close" @click="toggleModal = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body modal-body-lg">
                        <form @submit.prevent="submitForm">
                            <div class="form-group">
                                <div class="input-group">
                                    <div class="input-group-prepend w-100">
                                        <label class="input-group-text bg-transparent border-right-0" >
                                            <i class="fas fa-store"></i>
                                        </label>
                                        <multiselect v-model="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="selectByOutlet"></multiselect>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-sm-12 col-md-6">
                                    <div class="form-group">
                                        <label class="form-label">{{$t('label.price')}}</label>
                                        <div class="input-group bg-white shadow-inset-2">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text bg-transparent border-right-0">
                                                    <i class="fas fa-dollar-sign"></i>
                                                </span>
                                            </div>
                                            <input type="text" class="form-control pl-3" :placeholder="$t('label.price')" v-model="price" disabled>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6">
                                    <div class="form-group">
                                        <label class="form-label">{{$t('label.base_price')}}</label>
                                        <div class="input-group bg-white shadow-inset-2">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text bg-transparent border-right-0">
                                                    <i class="fas fa-dollar-sign"></i>
                                                </span>
                                            </div>
                                            <input type="text" class="form-control pl-3" :placeholder="$t('label.base_price')"  v-model="basePrice" disabled>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p v-if="currentQuantity != '-'" class="text-primary fw-500 fs-lg">{{$t('label.current_qty')}}: <span class="text-dark">{{currentQuantity}}</span></p>
                            <div class="form-group">
                                <div class="input-group">
                                    <div class="input-group-prepend w-100">
                                        <label class="input-group-text bg-transparent border-right-0" >
                                            <i class="fas fa-boxes-alt"></i>
                                        </label>
                                        <multiselect v-model="selectedType" label="text" track-by="id" :options="type" :searchable="false" :show-labels="false" openDirection="below" @select="selectByType"></multiselect>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-sm-12 col-md-6">
                                    <div class="form-group">
                                        <label class="form-label">{{$t('label.quantity')}}</label>
                                        <input class="form-control" type="number" :placeholder="$t('label.quantity')" step="any" v-model="quantity" :min="1" :max="499"/>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6">
                                    <div class="form-group">
                                        <label class="form-label">{{$t('label.cost')}}</label>
                                        <div class="input-group bg-white shadow-inset-2">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text bg-transparent border-right-0">
                                                    <i class="fas fa-dollar-sign"></i>
                                                </span>
                                            </div>
                                            <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.cost')" @keypress="isNumber($event)"  v-model="cost" required>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">{{$t('label.details')}}</label>
                                <textarea class="form-control" :placeholder="$t('label.details')" rows="5" v-model="details"></textarea>
                            </div>
                            <div class="text-left border-top pt-3 mt-3 mb-3">
                                <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
import {formatPrice, isNumber} from './../../../../assets/js/dashboard/utilities'
export default {
    name: 'stockInOut',
    data(){
        return{
            toggleModal: false, stockTitle: "",
            type: [
                {id: "in", text: this.$i18n.t('salon_report.stock.stock_in')},
                {id: "out", text: this.$i18n.t('salon_report.stock.stock_out')},
            ], selectedType: {id: "in", text: this.$i18n.t('salon_report.stock.stock_in')},
            outlet: [], selectedOutlet: 0, folderID: {}, price: 0, basePrice: 0, cost: 0,
            stockItem: {}, currentQuantity: 0, quantity: 1, details: ""
        }
    },
    watch:{
        "$i18n.locale"(val){
            this.setDropdown()
            var a = Object.assign({}, this.selectedOutlet)
            this.selectedOutlet = this.outlet.filter(obj=> obj.id == a.id)

            var b = Object.assign({}, this.selectedType)
            this.selectedType = this.type.filter(obj=> obj.id == b.id)
        }
    },
    methods:{
        isNumber(e){
            return isNumber(e);
        },
        stockInOut(outlet, item){
            this.toggleModal = true
            this.stockItem = item.items;
            this.folderID = (item.folder || {})['folderID']
            this.selectedOutlet = outlet;
            
            this.stockTitle = this.stockItem.name
            this.price = formatPrice((this.stockItem.price || {})['price'] || 0);
            this.basePrice = formatPrice((this.stockItem.price || {})['base'] || 0);
            this.cost = formatPrice((this.stockItem.price || {})['base'] || 0);
            this.currentQuantity = this.stockItem.total;
        },
        selectByOutlet(item){
            this.selectedOutlet = item;
        },
        selectByType(item){
            this.selectedType = item;
        },
        submitForm(){
            let $vm = this;
            const url =  $vm.$api.OUTLET + "/" + $vm.selectedOutlet.id + $vm.$api.STOCK;

            var data = {
                itemID: this.stockItem.skuID,
                price: this.cost,
                quantity: this.selectedType.id == "out" ? (0 - this.quantity) : this.quantity,
                detail: this.details
            }
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: data
            })
            .then((response) => {
                if(response.status == 200){
                    var retData = response.data;
                    var message = "'" + this.stockItem.name + "' " + $vm.$i18n.t('message.success.success',{'action':  $vm.selectedType.text})
                    $vm.$parent.$parent.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }else{
                    $vm.$parent.$parent.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'));
                }
            })
        },
        closeModal(isError){
             if(!isError){
                this.$emit('returnParent', this.folderID,)
                this.toggleModal = false
            }
            this.$parent.$parent.$parent.isModalShow = false;
        }, 
        setDropdown(){
            this.outlet = JSON.parse(this.$store.state.outlets);

            this.type = [
                {id: "in", text: this.$i18n.t('salon_report.stock.stock_in')},
                {id: "out", text: this.$i18n.t('salon_report.stock.stock_out')},
            ]
        }
    },
    mounted(){
        let $vm = this;
        $vm.setDropdown()
        $vm.selectedOutlet = $vm.outlet[0];
    }
}
</script>
<style scoped>
.show{
    display: block;
}
</style>